import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { bool, func, string, object } from 'prop-types';

import Input from 'library/components/form-elements/input';
import InfoTooltip from 'apps/journey/components/info-tooltip';
import { resolve } from 'library/helpers/path-resolver';
import withProfileFieldData from 'apps/journey/hoc/with-profile-field-data';

const StyledContainer = styled.div`
  display: flex;
  > * {
    &:first-child {
      flex: 1;
    }
  }
`;

class ProfileInput extends PureComponent {
  static propTypes = {
    delayInput: bool,
    label: string,
    onChange: func,
    value: bool,
    name: string,
    loadFromContext: bool,
    pattern: string,
    question: object,
    required: bool,
    type: string,
    tooltip: string,
  };

  constructor(props) {
    super(props);
  }

  state = {
    selection: '',
    loading: false,
  };

  handleOnChange = ({ target }) => {
    const { name, value } = target;
    this.setState({ loading: true });
    try {
      this.props.onChange({
        target: { id: resolve(this.props.question, 'id', null), answer: value },
      });
      this.setState(() => ({
        value: value,
        loading: false,
      }));
    } catch (err) {
      console.error(err);
      this.setState({
        loading: false,
      });
    }
  };

  render() {
    const {
      question,
      tooltip,
      label,
      name,
      pattern,
      delayInput,
      type,
      required,
    } = this.props;
    const savedResponse = resolve(
      question,
      'user_response/string_response',
      null
    );
    const tvalue = this.state.value || savedResponse;
    return (
      <StyledContainer>
        <Input
          onChange={this.handleOnChange}
          ariaLabel={question.title}
          label={label}
          name={name}
          value={tvalue}
          pattern={pattern}
          delayInput={delayInput}
          type={type}
          required={required}
        />
        {tooltip && (
          <InfoTooltip
            key={question.id}
            tooltip={tooltip}
            uid={question.id}
            iconOnly
          />
        )}
      </StyledContainer>
    );
  }
}

export default withProfileFieldData(ProfileInput);
